<template>
  <div id="datablog">
     <b-button  class="button is-primary"
            tag="router-link"
            to="/admin/berandablog"
            icon-left="arrow-left-bold">Kembali</b-button>
    
        <div id="content">
          <div class="box">
             <section>
             <div class="card" v-for="news in newses" :key="news.id">
              
              <div class="card-content">
                <div class="media">
                  <!-- <div class="media-content"> -->
                    <div class="container">
                        <div class="row">
                          <div class="column-66">
                            <h1 class="image animate__animated animate__backInUp" style="color:MediumSeaGreen;"><b>{{news.title}}</b></h1>
                            <p v-html="news.news" class="image animate__animated animate__backInUp"><span style="font-size:36px"></span></p>
                            <!-- <button class="button">Download Application</button> -->
                          </div>
                          <div class="column-33">
                             <figure class="image animate__animated animate__backInLeft" style="visibility: visible">
                              <img class="gambar-news"
                              height="50px" width="200px" :src="getPicture(news.picture)">
                            </figure>
                              <!-- <img src="/w3images/img_app.jpg" width="335" height="471"> -->
                          </div>
                        </div>
                      </div>
                    <!-- <p class="title is-4">{{ news.title }}</p>
                    <p class="subtitle is-6" v-html="news.news"></p> -->
                  <!-- </div> -->
                </div>
                
              </div>
              <!-- <footer class="card-footer" v-show="data.stok">
                
              </footer> -->
            </div>
            </section>
           
          </div>
        </div>
      </div>
</template>

<script>
export default {
  data() {
    return {
      newses:[],
      search:'',
      news:{
        title:'',
        news:'',
        picture:null,
      },
      news: new FormData,
      id_title:'',
      search:'',
      //tableLoadingIcon:'sync',
      tableMessage:'Loading...',
      detailOpened:[],
      isLoading:true,
      snackbarMessage:'',
    }
  },
   computed:{
    filteredList()
    {
      return this.newses.filter(news=>{
        return news.title.toLowerCase().includes(this.search.toLowerCase()) ||
        news.news.toLowerCase().includes(this.search.toLowerCase()) ||
        news.picture.toLowerCase().includes(this.search.toLowerCase()) 
      })
      
    }

  },
  methods: {
    getData()
    {
      this.isLoading=true
      var uri = this.$apiUrl + 'news'

      this.$http.get(uri).then(response =>
      {
        this.newses = response.data.value
        console.log(this.newses)
        for(var i=0; i<this.newses.length; i++)
        {
          this.newses[i].index = i+1
        }
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage ='Tidak ada data yang sesuai'
        this.isLoading=false
      })
      .catch(error =>{
        this.errors = console.error
        //this.tableLoadingIcon = "emoticon-sad"
        this.tableMessage='Tidak ada Data'
        this.isLoading = false
      })
    },
    getPicture(picture){
        var uri = this.$apiUrl + 'news/picture/' + picture
          
        return uri;
      },
    // deleteData(deleteID)
    // {
    //   var uri = this.$apiUrl + 'news/delete/' + deleteID

    //   this.$http.post(uri).then(response=>
    //   {
    //     this.getData();
    //     this.snackbarMessage = response
    //     this.snackbar('Data Berhasil dihapus','is-success')
    //   })
    //   .catch(error=>
    //   {
    //     this.errors = error
    //     this.snackbarMessage = "Silahkan coba hapus lagi"
    //     this.snackbar(this.snackbarMessage,'is-danger')
    //   })
    // },
    // snackbar(message,type)
    // {
    //   this.$buefy.toast.open({
    //     duration: 5000,
    //     message:message,
    //     type:type,
    //     position:'is-top',
    //     actionText:'OK',
    //     queue:false,
    //   })
    // },
    // confirmDelete(deleteID)
    // {
    //   this.$buefy.dialog.confirm({
    //     title:'Hapus News',
    //     message:'Apa anda yakin ingin menghapus ?',
    //     confirmText:'Hapus',
    //     cancelText:'Batal',
    //     type:'is-danger',
    //     hasIcon:true,
    //     onConfirm:() =>this.deleteData(deleteID)
    //   })
    // }  
  },
  mounted()
  {
    this.getData()
    console.log(this.search)
  }
}
</script>
<style scoped>
.card {
  margin-right: 10px;
  margin-bottom: 10px;
  max-width: 100%;
  height: 100%;
  box-shadow: none;
  border: solid 1px #dadbe6;
  border-radius: 10px;
  overflow: hidden;
}
.card-image {
  width: 100%;
  height: 150px;
  overflow: hidden;
  position: relative;
}
.gambar-news {
  width: 100%;
}
/* .card-content {
  padding: 15px 10px;
} */
.media-content {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
